<template>
    <div v-if="ordersStore.createOrderResponse != null">
        <div></div>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import {createOrderRequest} from "bestgob-core/api/models";
import * as Storage from 'bestgob-core/core/storage.js'
import Constants from "bestgob-core/core/constants";

export default {
    name: "Create",

    data() {
        return {

        }
    },

    watch: {
        '$store.state.orders.createOrderResponse'(){
            if (this.ordersStore.createOrderResponse != null){
                Storage.setItem(Constants.KEY_LAST_FISCAL_CONTACT, this.ordersStore.createOrderResponse.last_dato_solicitante_id.toString())

                let redirectUrl = this.getPaymentResponseUrl(this.ordersStore.createOrderResponse.order_id)
                let paymentUrl = this.ordersStore.createOrderResponse.payment_url+`?url_return=${redirectUrl}`
                // window.location.replace(paymentUrl)
                paymentUrl
            }
        },
        '$store.state.orders.paymentResponse'(){
            this.$forceUpdate();
            if (this.ordersStore.paymentResponse != null && this.ordersStore.paymentResponse.content && this.ordersStore.paymentResponse.success ){
                var doc = document.implementation.createHTMLDocument(); // Sandbox
                doc.body.innerHTML = this.ordersStore.paymentResponse.content; // Parse HTML properly
            }
        }
    },

    /*updated() {
        if (this.ordersStore.createOrderResponse != null){


            let button = document.getElementById('btn_proceder_pago')
            button.click()
        }
    },*/

    computed: {
        ...mapState({ordersStore: state => state.orders}),
    },

    mounted() {
        this.initCreateOrder()
    },

    methods: {
        ...mapActions('orders', ['createOrder']),

        initCreateOrder(){
            let request = createOrderRequest()
            request.cart = JSON.parse(Storage.getItem('finalCart'))
            request.data_invoice = JSON.parse(Storage.getItem('finalCartInvoice'))
            request.url_return = this.getPaymentResponseUrl()

            //VueX call
            this.createOrder(request)

            this.removeCartSession()
        },

        getPaymentResponseUrl(orderId = 'order_id'){
            const route = {name: 'orders_details', params: {action:'payment_response', id: orderId}}
            return window.location.origin + this.$router.resolve(route).href
        },

        removeCartSession(){
            Storage.removeItem('finalCart')
            Storage.removeItem('finalCartInvoice')
            Storage.removeItem('cart1')
            Storage.removeItem('cart2')
            Storage.removeItem('cart3')
        }
    }
}
</script>

<style scoped>

</style>